import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {
	getMyServiceInfo,
	getMyOrders,
	getMyInvoices,
	getMyInvoicesCount,
	getMyAmounts,
	getMyAutoPayInfo,
	getAutoPayAvailableCC,
	getAccountDistributionMethod,
	getAccountTypeDistributionMethods
} from '../../actions/homeInfoActions'
import {getAccountInfoById} from "../../actions/accountInfoActions";
import CustomerServices from './CustomerServices';
import {createLoadingSelector, selectHomeInfo, getAccountAutoPayStatus, selectLinkedAccounts, selectLinkedAccountsError, selectLinkedAccountsLoading, selectIsActive} from '../../selectors'
import {getCurrentPaymentProviderSupportsPaymentMethodStorage} from "../../actions/paymentProviderActions";
import {getUserPermissions} from "../../actions/authActions";
import LinkedAccount from "../../containers/LinkedAccounts/LinkedAccount"
import { fetchLinkedAccounts, fetchLinkedUsers } from '../../actions/linkedAccountsInfoActions';
import {toggleIsActive} from '../../actions/linkedAccountsInfoActions'
import {getAccountAutoPay} from "../../actions/autoPayActions";
import Loader from "../../components/common/Spinners/Loader";
import {getNotificationCategories} from "../../actions/notifications";

class Home extends Component {

	static propTypes = {
		accountInfo: PropTypes.object.isRequired
	};

	constructor(props) {
		super(props);
		this.state = {
			isActive: true,
			isLoading: false,
		};
	}

	componentDidMount() {
		const {
			accountInfo,
			getMyServiceInfo,
			getMyOrders,
			getMyInvoices,
			getMyInvoicesCount,
			getMyAmounts,
			getMyAutoPayInfo,
			getAutoPayAvailableCC,
			getAccountDistributionMethod,
			getAccountTypeDistributionMethods,
			getAccountAutoPay,
			getUserPermissions,
			fetchLinkedAccounts,
			fetchLinkedUsers
		} = this.props;

		this.setState({ isLoading: true });

		getMyInvoicesCount(accountInfo.id).then((count) => {
			return Promise.all([
				fetchLinkedAccounts(accountInfo.primaryContact.user.id),
				fetchLinkedUsers(accountInfo.id),
				getMyServiceInfo(accountInfo.id),
				getMyOrders(accountInfo.id),
				getMyInvoices(accountInfo.id, 10, 0),
				getMyAmounts(accountInfo.id),
				getMyAutoPayInfo(accountInfo.id),
				getAutoPayAvailableCC(accountInfo.id),
				getAccountDistributionMethod(accountInfo.id),
				getAccountTypeDistributionMethods(accountInfo.accountType.name),
				getUserPermissions()
			]);
		}).then(() => {
			this.setState({ isLoading: false });
		}).catch((error) => {
			console.error("Error fetching account info:", error);
			Promise.all([
				fetchLinkedAccounts(accountInfo.primaryContact.user.id),
				fetchLinkedUsers(accountInfo.id),
				getMyServiceInfo(accountInfo.id),
				getMyOrders(accountInfo.id),
				getMyInvoices(accountInfo.id, 10, 0),
				getMyAmounts(accountInfo.id),
				getMyAutoPayInfo(accountInfo.id),
				getAutoPayAvailableCC(accountInfo.id),
				getAccountDistributionMethod(accountInfo.id),
				getAccountTypeDistributionMethods(accountInfo.accountType.name),
				getUserPermissions()
			]).finally(() => {
				this.setState({ isLoading: false });
			});
		});
	}

	updateAccountInfo = async (accountId, accountTypeName) => {
		const {
			getMyServiceInfo,
			getMyOrders,
			getMyInvoices,
			getMyInvoicesCount,
			getMyAmounts,
			getMyAutoPayInfo,
			getAutoPayAvailableCC,
			getAccountDistributionMethod,
			getAccountTypeDistributionMethods,
			getUserPermissions,
			toggleIsActive,
			getNotificationCategories
		} = this.props;

		try {
			await getMyInvoicesCount(accountId);

			await Promise.all([
				getMyServiceInfo(accountId),
				getMyOrders(accountId),
				getMyInvoices(accountId, 10, 0),
				getMyAmounts(accountId),
				getMyAutoPayInfo(accountId),
				getAutoPayAvailableCC(accountId),
				getAccountDistributionMethod(accountId),
				getAccountTypeDistributionMethods(accountTypeName),
				getUserPermissions(),
				getNotificationCategories(accountId)
			]).then(() => {
				this.setState({isLoading: false});
			}).catch((error) => {
				console.error(error)
				this.setState({isLoading: false});
			});

			toggleIsActive(false);
		} catch (error) {
			console.error("Error updating account info:", error);
		}
	};

	handleManageClick = async (accountId, accountTypeName) => {
		this.setState({isLoading: true})


		try {
			const linkedAccountSelected = await this.props.getAccountInfoById(accountId);
			this.updateAccountInfo(this.props.accountInfo.id, this.props.accountInfo.accountType.name);
		} catch (err) {

		}
	}
	render() {



		const {
			accountInfo,
			myServiceInfoLoader,
			myOrdersInfoLoader,
			myInvoicesInfoLoader,
			myInvoices,
			myInvoicesCount,
			myInvoicesCountLoader,
			myAmounts,
			myAmountsLoader
		} = this.props;

		if (this.state.isLoading) {

			return <div className="cp-page cp-page-dashboard"> <Loader/></div>;
		}

		return (
			<div className="cp-page cp-page-dashboard">
				{/*<div className="container-alert-primary" />*/}

				{(this.props.linkedAccounts && this.props.linkedAccounts.linkedAccountList && this.props.linkedAccounts.linkedAccountList.length > 0 && this.props.isActive) ? (
					<LinkedAccount handleManageClick={this.handleManageClick} linkedAccounts={this.props.linkedAccounts} primaryAccountInfo={accountInfo}/>
				) : (
					<CustomerServices
						myServiceInfoLoader={myServiceInfoLoader}
						myOrdersInfoLoader={myOrdersInfoLoader}
						myInvoicesInfoLoader={myInvoicesInfoLoader}
						myInvoices={myInvoices}
						myInvoicesCount={myInvoicesCount}
						myInvoicesCountLoader={myInvoicesCountLoader}
						myAmounts={myAmounts}
						myAmountsLoader={myAmountsLoader}
						getMyInvoices={this.props.getMyInvoices}
						{...this.props}
					/>
				)}

				{/* <CustomerMenagment /> */}
			</div>
		);
	}
}
const getMyServiceInfoLoader = createLoadingSelector(['MY_SERVICE']);
const getMyOrdersInfoLoader = createLoadingSelector(['MY_ORDERS']);
const getMyInvoicesInfoLoader = createLoadingSelector(['MY_INVOICES']);
const getMyInvoicesCountLoader = createLoadingSelector(['MY_INVOICES_COUNT']);
const getMyAmountsLoader = createLoadingSelector(['MY_AMOUNTS']);

const mapStateToProps = (state) => {

	const homeInfo = selectHomeInfo(state);
	const myServiceInfo = homeInfo.myServiceInfo;
	const myServiceInfoLoader = getMyServiceInfoLoader(state);
	const myOrders = homeInfo.myOrders;
	const myOrdersInfoLoader = getMyOrdersInfoLoader(state);
	const myInvoices = homeInfo.myInvoices;
	const myInvoicesInfoLoader = getMyInvoicesInfoLoader(state);
	const myInvoicesCount = homeInfo.myInvoicesCount;
	const myInvoicesCountLoader = getMyInvoicesCountLoader(state);
	const myAmounts = homeInfo.myAmounts;
	const myAmountsLoader = getMyAmountsLoader(state);
	const myAutoPayInfo = homeInfo.myAutoPayInfo;
	const myAutoPayAvailableCC = homeInfo.myAutoPayAvailableCC;
	const myDistributionMethods = homeInfo.myDistributionMethods;
	const myCurrentDistributionMethod = homeInfo.myCurrentDistributionMethod;
	const myAutoPayStatus = getAccountAutoPayStatus(state);
	const myAutoPayWarning = getAccountAutoPayStatus(state).autoPayWarningMessage;
	const linkedAccounts = selectLinkedAccounts(state);
	const loading = selectLinkedAccountsLoading(state);
	const error = selectLinkedAccountsError(state);
	const isActive = selectIsActive(state);


		return {
		myServiceInfo,
		myServiceInfoLoader,
		myOrders,
		myOrdersInfoLoader,
		myInvoices,
		myInvoicesInfoLoader,
		myInvoicesCount,
		myInvoicesCountLoader,
		myAmounts,
		myAmountsLoader,
		myAutoPayInfo,
		myAutoPayAvailableCC,
		myDistributionMethods,
		myCurrentDistributionMethod,
		linkedAccounts,
		loading,
		error,
		isActive
	}
};

const mapDispatchToProps = {
	getMyServiceInfo,
	getMyOrders,
	getMyInvoices,
	getMyInvoicesCount,
	getMyAmounts,
	getMyAutoPayInfo,
	getAccountAutoPay,
	getAutoPayAvailableCC,
	getAccountDistributionMethod,
	getAccountTypeDistributionMethods,
	getCurrentPaymentProviderSupportsPaymentMethodStorage,
	getUserPermissions,
	fetchLinkedAccounts,
	getAccountInfoById,
	toggleIsActive,
	fetchLinkedUsers,
	getNotificationCategories

};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
